import { render, staticRenderFns } from "./ElectricianPowerCompanies.vue?vue&type=template&id=593cd45f"
import script from "./ElectricianPowerCompanies.vue?vue&type=script&lang=js"
export * from "./ElectricianPowerCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports